define('Components/AdvancedTemplatingWidget/js/AdvancedTemplatingWidget',['hooks','AutoloadAdvancedTemplatingWidget'],
    function(hooks,AutoloadAdvancedTemplatingWidget){
    return function() {
        AutoloadAdvancedTemplatingWidget(hooks);
    }
});
